import { useEffect, useState } from "react";

const breakpoints = {
  mobile: 480,
  tablet: 768,
  laptop: 1024,
};

function getDeviceType() {
  const width = window.innerWidth;
  if (width <= breakpoints.mobile) return "mobile";
  if (width <= breakpoints.tablet) return "tablet";
  if (width <= breakpoints.laptop) return "laptop";
  return "desktop";
}

export function useDeviceType() {
  const [deviceType, setDeviceType] = useState(getDeviceType);

  useEffect(() => {
    const handleResize = () => setDeviceType(getDeviceType());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return deviceType;
}
